import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Web2ServiceService } from '../../../services/web2-service.service';
import { WalletService } from '../../../services/wallet.service';
import { AuthService } from '../../../services/auth.service';
import { Hex } from 'viem';
import { ApiService } from '../../../services/api.service';
import { ToastService } from '../../../services/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LoaderService } from '../../../services/loader.service';

@Component({
  selector: 'app-modal-helper',
  imports: [NgIf],
  templateUrl: './modal-helper.component.html',
  styleUrl: './modal-helper.component.css'
})
export class ModalHelperComponent {

  option:string = "";
  isProcessing: boolean = false;
  @Input() optionEnabled: string = "";
   @Output() closeModal = new EventEmitter<void>();
  constructor(
    private auth: AuthService,
    private service: ApiService,
    private toastr: ToastService,
    private walletservice: WalletService,
    private web2service: Web2ServiceService,
    private loader: LoaderService
  ) {
    this.auth.operation
      .subscribe((name: string) => {
        if (name == "enable-trading")
          this.option = name;
      })
  }

  /**
   * Close Modal
   */
  close(): void {
    this.option = "";
  }

  /**
   * Close Enable Trading Modal
   */
  closeEnableModal() {
    this.closeModal.emit();
  }

  async generateSignature(): Promise<void> {
    let details: any = this.auth.getLoginOption();
    let userdata: any = this.auth.getUserData();
    let signature: any = null;

    this.isProcessing = true;
    this.loader.show();
    try {
      if (details.type == "web2")
        signature = await this.web2service.generateSignature(userdata.public_address);
      else
        signature = await this.walletservice.generateSignature();

    if (signature) {
      let parsedData = this.walletservice.getSignatureParams(signature as `0x${string}`);
      console.log("Enabling trading for Web2 user in modal helper components", parsedData);
      this.service.enableTrading(parsedData)
        .subscribe((result: any) => {
          this.loader.hide();
          userdata.enable_trading = true;
          this.auth.setUserData(userdata);
          this.closeEnableModal();
          this.toastr.success("You're activated the trade service successfully.");
          this.close();
        }, (error: HttpErrorResponse) => {
          this.loader.hide();
          this.isProcessing = false;
          console.log(error);
          this.toastr.error("Something went wrong. Please try later.")
        })
    } else {
      this.loader.hide();
      this.isProcessing = false;
    }
    } catch (error: any) {
      this.loader.hide();
      this.isProcessing = false;
      console.log(error);
      const errorMsg = error?.message?.toLowerCase() || '';
      if (error?.code === 4001 || errorMsg.includes('user denied') || errorMsg.includes('rejected') || errorMsg.includes('user cancelled')) {
        this.toastr.error("Signature request was cancelled.");
      } else {
        this.toastr.error("Something went wrong with the signature. Please try again.");
      }
    }
  }
}
